/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { Collapse, ClickAwayListener } from '@material-ui/core';

import inspectionStyles from '../checklist.module.scss';
import Clickable from '../../../../../../components/clickable/Clickable';
import Button from '../../../../../../components/button';
import Modal from '../../../../../../components/modal';
import PulpoField from '../../../../../../pulpo_visualizer/fields';
import FileSlider from '../../../../../../components/photoCarousel/FileSlider';

import styles from './checklistComponent.module.scss';
import InspectionDropdownComp, { evaluateToleranceStatus } from './InspectionDropdown';
import {
  fetchInspection,
  clearRemark
} from '../../../../redux/actions';
import Loading from '../../../../../../components/loading/loading';

class InspectionChecklistItem extends Component {
  state = {
    openRemarks: false,
    actionsShow: false,
    openWorkorders: false,
    openNotamsModal: false,
    currentRemark: '',
    currentPhoto: [],
    workorders: [],
    RemarkDescriptionEmpty: false,
    invalidImage: false,
    current: [],
    currentRemarks: [],
    loadingStatus: false,
    modal: false,
    maintenanceWorkorders: false,
    airfieldModal: false,
    deleteModal: false,
    slideModal: false,
    locModal: false,
    location: {},
    locDetail: false,
    statusPillOpen: false,
    actionDropdown: false
  };

  imageStyles = {
    width: '100px',
    height: '70px',
    position: 'relative',
    left: '80%',
    bottom: '20px',
    marginLeft: '10px',
    marginTop: '5px'
  };

  transitionStyles = {
    entered: { maxHeight: '100vh' }
  };

  WOtransitionStyles = {
    entered: { maxHeight: '100vh' }
  };

  textareaStyles = {
    margin: '30px 25px 0px 10px',
    border: '1px solid #E6EAEE',
    borderRadius: '4px',
    width: '670px',
    maxHeight: 60,
    minHeight: 60,
    resize: 'none'
  };

  labelStyles = {
    bottom: 43,
    fontSize: 15
  };

  spanStyle = {
    width: '50%'
  };

  componentDidMount() {
    const {
      itemKey,
      workorders,
      handleItemStatusChange,
      pass,
      MaintenanceWorkorders,
      airfieldWorkorders,
      actionClearRemark,
      workorder_satisfactory,
      selfInspection,
      remarks,
      columnsData,
      standards,
      handleColumnStatusChange,
      isColumn,
      inspection: { default_satisfactory, tolerance_inspection }
    } = this.props;
    actionClearRemark();
    if (selfInspection && workorders.length > 0) {
      if (!workorder_satisfactory || pass === undefined) handleItemStatusChange(itemKey, false);
      this.setState({ workorders });
    }
    if (MaintenanceWorkorders.length > 0) {
      if (!workorder_satisfactory || pass === undefined) handleItemStatusChange(itemKey, false);
    }
    if (airfieldWorkorders.length > 0) {
      if (!workorder_satisfactory || pass === undefined) handleItemStatusChange(itemKey, false);
    }
    if (remarks?.length > 0) {
      this.setState({ currentRemarks: remarks });
    }

    // Initialize default satisfactory status if untouched
    if (pass === undefined && workorders.length === 0 && MaintenanceWorkorders.length === 0 && airfieldWorkorders.length === 0) {
      const isToleranceItem = tolerance_inspection && (standards?.standard || standards?.tolerance_type === 'capture_input');
      if (!isColumn) {
        if (default_satisfactory && !isToleranceItem) {
          handleItemStatusChange(itemKey, true);
        }
      } else if (columnsData && default_satisfactory) {
        columnsData.forEach((data) => {
          handleColumnStatusChange(itemKey, data.key, true);
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      fetchRemarksAction,
      remarks,
      itemKey: currentItemKey
    } = this.props;
    if (
      prevProps?.fetchRemarksAction?.loading === true
      && fetchRemarksAction?.loading === false
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        loadingStatus: fetchRemarksAction.loading,
        currentRemarks: remarks
      });
    }

    const {
      statusPillOpen: prevStatusPillOpen,
      actionDropdown: prevActionOpen
    } = prevState;
    const { statusPillOpen, actionDropdown } = this.state;

    if (prevStatusPillOpen !== statusPillOpen || prevActionOpen !== actionDropdown) {
      const container = document.getElementById('checklist-button-container');
      if (container) {
        const SPACE_THRESHOLD_PX = 200;
        const MARGIN_BOTTOM_PX = '80px';

        if (statusPillOpen || actionDropdown) {
          const itemDiv = document.getElementById(`checklist-item-${currentItemKey}`);
          if (itemDiv) {
            const rect = itemDiv.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            if (spaceBelow < SPACE_THRESHOLD_PX) {
              container.style.marginBottom = MARGIN_BOTTOM_PX;
            } else {
              container.style.marginBottom = '0px';
            }
          } else {
            container.style.marginBottom = MARGIN_BOTTOM_PX;
          }
        } else if (prevStatusPillOpen || prevActionOpen) {
          // Guard: Only reset if we were the ones who had it open
          container.style.marginBottom = '0px';
        }
      }
    }
  }

  componentWillUnmount() {
    const { statusPillOpen, actionDropdown } = this.state;
    if (statusPillOpen || actionDropdown) {
      const container = document.getElementById('checklist-button-container');
      if (container) {
        container.style.marginBottom = '0px';
      }
    }
  }

  handleChange = (key, value, section) => {
    if (key === 'currentPhoto' && value === undefined) {
      return;
    }
    if (section === 'currentRemark') {
      this.setState(prevState => ({
        [section]: {
          ...prevState[section],
          [key]: value
        }
      }));
    } else {
      this.setState({ [key]: value });
    }
    this.setState({ invalidImage: false });
    this.setState({ RemarkDescriptionEmpty: false });
  };

  handleCreateClick = () => {
    const { handleItemRemarkChange, itemKey } = this.props;
    const { currentRemark, currentRemarks } = this.state;
    if (currentRemark?.text?.trim()?.length === 0 && (!currentRemark?.attachments || currentRemark?.attachments?.length === 0)) {
      this.setState({ RemarkDescriptionEmpty: true });
      this.setState({ loadingStatus: false });
      return;
    }

    if (currentRemark?.text?.trim()?.length > 0 || currentRemark?.attachments?.length > 0) {
      if (currentRemark?.attachments?.length > 0) {
        currentRemark.attachments.forEach((i) => {
          if (!i.id && !i.name.match(/\.(jpg|jpeg|png|gif|PNG)$/)) {
            this.setState({ invalidImage: true });
          }
        });
      }
      this.setState({ loadingStatus: true });
      let remarkData = currentRemark;
      if (currentRemark?.attachments?.length > 0) {
        const images = [];
        currentRemark.attachments.forEach((i) => {
          if (!i.id) {
            const reader = new FileReader();
            reader.readAsDataURL(i);
            // eslint-disable-next-line func-names
            reader.onloadend = function () {
              images.push(reader.result);
              // eslint-disable-next-line no-extra-bind
            }.bind(this);
          } else {
            images.push(i);
          }
        });
        const currentList = [
          ...currentRemarks,
          {
            ...currentRemark,
            attachments: images
          }
        ];
        this.setState({
          currentRemark: {
            ...currentRemark,
            attachments: images
          },
          currentRemarks: currentList
        });
      } else {
        const currentList = [
          ...currentRemarks,
          currentRemark
        ];
        this.setState({
          currentRemarks: currentList
        });
      }

      handleItemRemarkChange(itemKey, remarkData);
      this.handleChange('openRemarks', false);
    }
  };

  handleCancel = () => {
    const { currentRemark, currentRemarks } = this.state;
    const { remarks } = this.props;
    const allRemarks = [...currentRemarks];
    if (currentRemark && Object.keys(currentRemark)?.length > 0 && currentRemark?.id) {
      allRemarks.push(
        remarks?.filter(rem => rem?.id === currentRemark?.id)?.[0]
      );
    }
    this.setState({
      openRemarks: false,
      currentRemarks: allRemarks,
      currentRemark: {
        text: ''
      }
    });
  };

  toggleModal = (modal, value) => {
    this.setState({ [modal]: value });
  };

  handleAddWorkorder = () => {
    this.toggleModal('modal', true);
    this.setState({ maintenanceWorkorders: true });
  };

  toggleAirfieldWorkordersModal = (airfieldModal, value) => {
    this.setState({ [airfieldModal]: value });
  };

  handleAddAirfieldWorkorder = () => {
    this.toggleAirfieldWorkordersModal('airfieldModal', true);
  };

  handleRemoveImage = (e) => {
    const { currentRemark } = this.state;
    let currentPhotos = currentRemark?.attachments || [];
    if (!e.id) {
      currentPhotos = currentPhotos.filter(photo => photo !== e);
    } else if (e?.id) {
      currentPhotos = currentPhotos.filter(photo => photo?.id !== e.id);
    }
    this.setState({ currentRemark: {
      ...currentRemark,
      attachments: [...currentPhotos]
    } });
  }

  handleToleranceResult = (value) => {
    const { itemKey, handleItemStatusChange, handleItemToleranceResultChange, standards } = this.props;

    if (value === 'N/A') {
      handleItemStatusChange(itemKey, 'N/A');
    } else {
      const result = evaluateToleranceStatus(value, standards);
      handleItemStatusChange(itemKey, result);
    }
    handleItemToleranceResultChange(itemKey, value);
  }

  handleColumnToleranceResult = (columnId, value) => {
    const { itemKey, standards, handleColumnStatusChange, handleColumnToleranceResultChange } = this.props;
    if (value === 'N/A') {
      handleColumnStatusChange(itemKey, columnId, 'N/A');
    } else {
      const result = evaluateToleranceStatus(value, standards);
      handleColumnStatusChange(itemKey, columnId, result);
    }
    handleColumnToleranceResultChange(itemKey, columnId, value);
  }

  handleActionSelection = (selected) => {
    if (selected === 'New Remark') {
      this.setState({ currentRemark: { text: '' } });
      this.handleChange('openRemarks', true);
    } else if (selected === 'New Work Order') {
      this.handleChange('openWorkorders', true);
    } else if (selected === 'Attach NOTAMS') {
      this.handleChange('openNotamsModal', true);
    } else if (selected === 'Wildlife Log' || selected === 'FOD Log') {
      this.handleChange('openActionsModal', true);
    } else if (selected === 'Connect_NAWO') {
      this.handleAddWorkorder();
    } else if (selected === 'Connect_AWO') {
      this.handleAddAirfieldWorkorder();
    }
    this.setState({ actionDropdown: false });
  }

  handleAction(selectedRemark) {
    const { remarks } = this.props;
    const remarkId = remarks.find(remark => remark.id === selectedRemark);
    if (remarkId.id === selectedRemark) {
      this.setState(prevState => ({
        actionsShow: {
          ...prevState.actionsShow,
          [selectedRemark]: !prevState.actionsShow[selectedRemark]
        }
      }));
    }
  }

  handleRemarkEdit = (remark, action) => {
    const { currentRemarks } = this.state;
    if (action === 'edit') {
      this.handleChange('openRemarks', true);
      const remainingRemarks = currentRemarks?.filter(rem => (
        rem?.id !== remark?.id
      ));
      this.setState({
        currentRemark: remark,
        currentRemarks: [...remainingRemarks]
      });
    } else if (action === 'delete') {
      this.setState({ deleteModal: true, currentRemark: remark });
    }
  }

  handleRemarkDelete = () => {
    const { handleItemRemarkChange, itemKey } = this.props;
    const { currentRemark, currentRemarks } = this.state;

    const remainingRemarks = currentRemarks?.filter(rem => (
      rem?.id !== currentRemark?.id
    ));

    handleItemRemarkChange(itemKey, {
      action: 'delete',
      ...currentRemark
    });

    this.setState({
      currentRemark: {
        text: ''
      },
      currentPhoto: [],
      deleteModal: false,
      currentRemarks: remainingRemarks
    });
  }

  render() {
    const {
      pass,
      title,
      itemKey,
      inspection,
      MaintenanceWorkorders,
      checkColumnData,
      columnsData,
      handleItemStatusChange,
      handleColumnStatusChange,
      airfieldWorkorders,
      workorder_satisfactory,
      enableNA,
      toleranceItemResult,
      toleranceColumnData,
      standards,
      checklistSettings,
      user,
      checklistAttachments,
      onlyCaptureInput
    } = this.props;
    const {
      openRemarks,
      currentRemark,
      currentRemarks,
      workorders,
      invalidImage,
      loadingStatus,
      RemarkDescriptionEmpty,
      actionDropdown,
      actionSelected,
      deleteModal,
      slideModal,
      locModal,
      location,
      locDetail
    } = this.state;
    let Tag = workorders.length > 0
      || MaintenanceWorkorders.length > 0
      || airfieldWorkorders.length > 0
      ? 'div'
      : Clickable;
    if (workorder_satisfactory) Tag = Clickable;
    if (inspection?.tolerance_inspection && standards?.standard) Tag = 'div';
    const isToleranceItem = inspection?.tolerance_inspection && (standards?.standard || standards?.tolerance_type === 'capture_input');
    let itemStatusStyle;
    if (pass === undefined) {
      itemStatusStyle = (inspection?.default_satisfactory && !isToleranceItem)
        ? inspectionStyles.success
        : inspectionStyles.untouched;
    } else if (enableNA && pass === 'N/A') {
      itemStatusStyle = inspectionStyles.na;
    } else if (enableNA && checkColumnData && Object.values(checkColumnData)?.includes('N/A')) {
      itemStatusStyle = inspectionStyles.na;
    } else {
      itemStatusStyle = pass
        ? inspectionStyles.success
        : inspectionStyles.failure;
    }
    const attachments = checklistAttachments?.filter(chAttach => (
      chAttach?.attachment_id === checklistSettings?.attachments?.[0]?.attachment_id
    ));
    let checkItemNameWidth;
    if (inspection?.tolerance_inspection && !onlyCaptureInput) checkItemNameWidth = '200px';
    else if (inspection?.tolerance_inspection && (standards?.standard || standards?.tolerance_type === 'capture_input')) checkItemNameWidth = '425px';
    const isStatusDisabled = Tag !== Clickable;
    const hasColumns = columnsData && columnsData.length > 0;
    const inspectionNames = inspection?.nomenclature || {};

    return (
      <>
        <Loading loadingStatus={loadingStatus} />
        <div className={styles.itemWrapper} id={`checklist-item-${itemKey}`}>
          <div className={styles.checklist__item}>
            <span className={styles.checklist__item__data} style={checkItemNameWidth ? { width: checkItemNameWidth } : {}}>
              <span
                className={`${inspectionStyles.statusDot} ${itemStatusStyle}`}
              />
              <div className="text-truncate" style={{ width: '400px' }} id={`Popover-${standards.key}`}>
              {title}
              {(title || '')?.length > 30 && (
                <UncontrolledPopover trigger="hover legacy"
                  placement="right"
                  target={`Popover-${standards.key}`}
                  flip
                >
                  <PopoverBody style={{ padding: '10px 10px 10px 15px' }}>
                    {title}
                  </PopoverBody>
                </UncontrolledPopover>
              )}
              </div>
            </span>
            <div className={styles.remarkWrapper}>
              <ClickAwayListener onClickAway={() => this.setState({ actionDropdown: false })}>
                <div className={`${styles.inspection_dropdown} ${styles.actionsDropdown} ${actionDropdown ? styles.open : ''}`}>
                    <span
                      className={styles.dropdownTrigger}
                      role="button"
                      tabIndex={0}
                      onClick={() => this.setState({ actionDropdown: !actionDropdown })}
                      onKeyPress={() => this.setState({ actionDropdown: !actionDropdown })}>
                      {actionSelected || 'Actions'}
                    </span>
                    <Collapse in={actionDropdown}>
                      <ul className={styles.actionList_dropdown}>
                          {!openRemarks && (
                            <li>
                              <span role="button" tabIndex="0" onClick={() => this.handleActionSelection('New Remark')}
                            onKeyPress={() => this.handleActionSelection('New Remark')}>
                              <FormattedMessage
                                id="inspections.complete_inspections.remarks"
                                defaultMessage="New Remark"
                              />
                              </span>
                            </li>
                          )}
                      </ul>
                    </Collapse>
                </div>
              </ClickAwayListener>
              {inspection?.tolerance_inspection && !onlyCaptureInput && (
                <>
                  <div className={styles.remarks}>
                    {standards?.standard ? (
                      <span className={styles.standard}>
                        {standards?.operator}
                        {standards?.standard}
                        {standards?.units}
                      </span>
                    ) : <span className={styles.standard} />}
                  </div>
                  <div className={styles.remarks}>
                    {(standards?.tolerance && standards?.standard) ? (
                      <span className={styles.standard}>
                          &plusmn;
                        {standards?.tolerance}
&nbsp;
                        {standards?.units}
                      </span>
                    ) : <span className={styles.standard} />}
                  </div>
                </>
              )}
            </div>
            <div className={`${styles.checkWrap} ${hasColumns ? styles.columnCheckWrap : ''}`}>
              {hasColumns ? (
                columnsData.map(f => (
                  <div key={f.key || f.value} className={styles.standard}>
                    {inspection?.tolerance_inspection && (standards?.standard || standards?.tolerance_type === 'capture_input') ? (
                      <div>
                        <div className={styles.columnStandard}>
                          <input
                            type="number" name="result" value={toleranceColumnData?.[f.key]}
                            onChange={e => this.handleColumnToleranceResult(f.key, e.target.value)}
                          />
                        </div>
                      </div>
                    ) : (
                      <InspectionDropdownComp
                        handleColumnStatusChange={checked => handleColumnStatusChange(itemKey, f.key, checked)}
                        selectedValue={checkColumnData?.[f.key]}
                        isActive
                        disabled={isStatusDisabled}
                        enableNA={enableNA}
                        toleranceInput={inspection?.tolerance_inspection && (standards?.standard || standards?.tolerance_type === 'capture_input')}
                        toleranceValue={toleranceColumnData?.[f.key]}
                        standards={standards}
                        nomenclature={inspectionNames}
                        defaultSatisfactory={inspection?.default_satisfactory}
                        onToggle={open => this.setState({ statusPillOpen: open })}
                      />
                    )}
                  </div>
                ))
              ) : (
                <div className={styles.standard}>
                  {!(inspection?.tolerance_inspection && (standards?.standard || standards?.tolerance_type === 'capture_input')) && (
                    <div className={`${styles.checklist__item__btnContainer} ${styles.checklist__item__data}`}>
                      <InspectionDropdownComp
                        handleColumnStatusChange={checked => handleItemStatusChange(itemKey, checked)}
                        selectedValue={pass}
                        isActive
                        disabled={isStatusDisabled}
                        enableNA={enableNA}
                        nomenclature={inspectionNames}
                        defaultSatisfactory={inspection?.default_satisfactory}
                        onToggle={open => this.setState({ statusPillOpen: open })}
                      />
                    </div>
                  )}
                  {(inspection?.tolerance_inspection && (standards?.standard || standards?.tolerance_type === 'capture_input')) && (
                    <div>
                      <div className={styles.standard}>
                        <input
                          type="number" name="result" value={toleranceItemResult}
                          onChange={e => this.handleToleranceResult(e.target.value)}
                        />
                        {enableNA && (
                          <InspectionDropdownComp
                            handleColumnStatusChange={checked => handleItemStatusChange(itemKey, checked)}
                            selectedValue={pass}
                            isActive
                            disabled={isStatusDisabled}
                            enableNA={enableNA}
                            toleranceInput
                            toleranceValue={toleranceItemResult}
                            standards={standards}
                            nomenclature={inspectionNames}
                            defaultSatisfactory={inspection?.default_satisfactory}
                            onToggle={open => this.setState({ statusPillOpen: open })}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          {attachments?.length > 0 && (
            <>
              <div className={styles.remark} style={{ border: 'none' }}>
                <Clickable onClick={() => this.setState({ slideModal: true })}>
                  <img src={attachments?.[0]?.url} alt={attachments?.[0]?.file_name || ''} width="600" height="300" />
                </Clickable>
              </div>
              <Modal
                showIn={slideModal}
                onClose={() => { this.setState({ slideModal: false }); }}
                contentStyles={{
                  overflow: 'visible',
                  background: '#E6EAEE',
                  padding: '20px 40px'
                }}
              >
                <div>
                  <FileSlider
                    photos={attachments}
                    initialSlide={0}
                  />
                </div>
              </Modal>
            </>
          )}
          {currentRemarks?.length > 0 && currentRemarks?.map(remark => (
            <div className={styles.remark} key={remark.id}>
              <div className={styles.actionParent}>
                <span className={styles.label}>
                  <FormattedMessage
                    id="workorders.remarks"
                    defaultMessage="Remarks"
                  />
                </span>
                <div className={styles.actionBtn} style={{ paddingRight: '26px' }}>
              <Clickable
                className={styles.actionsBtn}
                onClick={() => this.handleAction(remark.id)}
              >
                <FormattedMessage
                  id="workorders.detail.actionBtn"
                  defaultMessage="Actions"
                />
              </Clickable>
              {this.state.actionsShow[remark.id] && (
              <>
                <ul className={styles.actionlistUl}>
                {!openRemarks && (
                  <li>
                    <span role="button" tabIndex={0} onClick={() => this.handleRemarkEdit(remark, 'edit')}
                  onKeyPress={() => this.handleRemarkEdit(remark, 'edit')}>
                      <FormattedMessage
                        id="inspections.step0.edit"
                        defaultMessage="Edit"
                      />
                    </span>
                  </li>
                )}
                </ul>
              <ul className={styles.actionlistUl}>
                {!openRemarks && (
                  <li>
                    <span role="button" tabIndex={0} onClick={() => this.handleRemarkEdit(remark, 'delete')}
                  onKeyPress={() => this.handleRemarkEdit(remark, 'delete')}>
                      <FormattedMessage
                        id="assets.delete"
                        defaultMessage="Delete"
                      />
                    </span>
                  </li>
                )}
              </ul>
              </>
              )}
                </div>
              </div>
              <span style={this.spanStyle}><pre>{remark.text}</pre></span>
              <div
                style={
                  remark?.attachments?.length > 2
                    ? { marginRight: '334px' }
                    : { marginRight: '130px' }
                }
              >
                {remark?.attachments?.length > 0
                  ? remark?.attachments?.map(i => (
                      <img src={i.image || i} style={this.imageStyles} alt="" />
                    ))
                  : ''}
              </div>
            </div>
          ))}
          {openRemarks && (
          <Transition in={openRemarks} timeout={0}>
            {state => (
              <div
                className={styles.remarkInput}
                style={this.transitionStyles[state]}
              >
                {(currentRemark?.attachments?.length > 0) && (
                  <div className={styles.photos}>
                    {currentRemark?.attachments?.length > 0 && currentRemark?.attachments.map(e => (
                      <div key={e.name} className={styles.wrapper}>
                        <Clickable onClick={() => this.handleRemoveImage(e)}>
                          &times;
                        </Clickable>
                        <p>{e.name || e.file_name}</p>
                      </div>
                    ))}
                  </div>
                )}
                {invalidImage && (
                  <div className={styles.error}>
                    <FormattedMessage
                      id="pulpoforms.errors.invalid_image"
                      defaultMessage="Upload a valid image"
                    />
                  </div>
                )}
                <label style={this.labelStyles}>
                  <FormattedMessage
                    id="todo.details.description"
                    defaultMessage="Description"
                  />
                </label>
                <textarea
                  rows="2"
                  defaultValue={currentRemark?.text || ''}
                  value={currentRemark?.text || ''}
                  onChange={e => this.handleChange('text', e.target.value, 'currentRemark')}
                  style={this.textareaStyles}
                  name={`${currentRemark?.id || 'new'}`}
                />
                {RemarkDescriptionEmpty && (
                  <div className={styles.error}>
                    <FormattedMessage
                      id="pulpoforms.errors.not_blank"
                      defaultMessage="This field cannot be empty"
                    />
                  </div>
                )}
                {checklistSettings?.defined_remarks && Object.keys(checklistSettings?.defined_remarks)?.length > 0 && (
                  <div className={styles.remarkPredefined}>
                    {Object.values(checklistSettings?.defined_remarks)?.map(rT => (
                      <Clickable className={styles.predefinedText} onClick={() => this.handleChange('text', rT, 'currentRemark')}>
                        {rT?.length > 50 ? `${rT?.slice(0, 50)}...` : rT}
                      </Clickable>
                    ))}
                  </div>
                )}
                <Button
                  action="teritary"
                  translationID="inspections.new.cancelBtn"
                  defaultText="Cancel"
                  onClick={this.handleCancel}
                />
                <Button
                  action="secondary"
                  translationID="inspections.new.addBtn"
                  defaultText="Save"
                  onClick={this.handleCreateClick}
                />
              </div>
            )}
          </Transition>
          )}
        </div>
        <Modal
          onClose={() => this.setState({ deleteModal: false })}
          showIn={deleteModal}
          width="370px"
          minHeight="180px"
        >
          <h3 className={styles.toggle}>
            <FormattedMessage
              tagName="p"
              id="inspections.complete.remark_delete"
              defaultMessage="Are you sure you want to delete the remark?"
            />
          </h3>
          <div className={styles.footer}>
            <Button
              onClick={() => this.setState({ deleteModal: false })}
              translationID="roles.footer.No"
              defaultText="No"
              action={deleteModal === false ? 'secondary' : 'teritary'}
              style={{ color: 'gray' }}
            />
            <Button
              onClick={this.handleRemarkDelete}
              translationID="roles.footer.Yes"
              defaultText="Yes"
              action={deleteModal === true ? 'secondary' : 'teritary'}
              style={{ minHeight: '10px' }}
            />
          </div>
        </Modal>
        <Modal
          onClose={() => this.setState({ locModal: false, location: {} })}
          showIn={locModal}
          width="900px"
          minHeight="180px"
        >
          <div className={styles.locHeader}>
            <FormattedMessage
              tagName="h3"
              id="inspections.complete.select_loc"
              defaultMessage="Select Location"
            />
          </div>
          <div className={styles.locContent}>
            <PulpoField key="location" id="location"
              type="map_location" shape="Point"
              translationID="workorder.create.location"
              className={styles.fullInput} title="Location"
              isRequired
              handleValueChange={(a, b) => this.setState({ [b]: a })}
              answer={location}
              disabled={locDetail}
              handleFieldErrorChanged={() => {}}
              handleZoomLevel={val => this.handleZoomLevel(val)}
              mapSetting={user && user.airport_settings && user.airport_settings.map_style}
            />
          </div>
          <div className={styles.locFooter}>
            {!locDetail && (
              <Button
                onClick={() => {
                  this.setState({ locModal: false });
                  this.handleChange('location', location, 'currentRemark');
                }}
                translationID="assets.save"
                defaultText="Save"
                action="secondary"
                style={{ minHeight: '10px' }}
              />
            )}
            <Button
              onClick={() => this.setState({ locModal: false, location: {} })}
              translationID="filter.cancel"
              defaultText="Cancel"
              action="teritary"
              style={{ color: 'gray' }}
            />
          </div>
        </Modal>
      </>
    );
  }
}

InspectionChecklistItem.propTypes = {
  title: PropTypes.string.isRequired,
  itemKey: PropTypes.string.isRequired,
  pass: PropTypes.bool,
  isColumn: PropTypes.bool,
  handleItemStatusChange: PropTypes.func.isRequired,
  handleColumnStatusChange: PropTypes.func.isRequired,
  handleItemRemarkChange: PropTypes.func.isRequired,
  remark: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
};

InspectionChecklistItem.defaultProps = {
  remark: '',
  pass: undefined,
  isColumn: false
};

const mapStateToProps = state => ({
  connectWorkordersAction: state.lease.connectWorkordersAction,
  disconnectWorkorderAction: state.inspection.disconnectWorkorderAction,
  fetchConnectedWorkordersAction:
    state.inspection.fetchConnectedAirfieldWorkordersAction,
  connectedWorkOrders: state.inspection.connectedAirfieldWorkOrders,
  disconnectAirfieldWorkorderAction:
    state.inspection.disconnectAirfieldWorkorderAction,
  user: state.auth.profile
}); // Please review your data

const mapDispatchToProps = dispatch => ({
  actionFetch: (id) => {
    dispatch(fetchInspection(id));
  },
  actionClearRemark: () => {
    dispatch(clearRemark());
  }
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InspectionChecklistItem)
);
